import Axios from 'axios'
import React, { FormEvent, useEffect, useState } from 'react'
import { FunctionComponent } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { DriverFio } from '../drivers/driverFio'

export const EditBonus: FunctionComponent = () => {
  const [disabled, setDisabled] = useState(false)
  const [date, setDate] = useState('')
  const [amount, setAmount] = useState(0)
  const [comment, setComment] = useState('')

  const { driverId } = useParams<{ driverId: string }>()
  const { bonusId } = useParams<{ bonusId: string }>()

  useEffect(() => {
    const loadBonus = async () => {
      setDisabled(true)

      try {
        const bonus = await Axios.get<{
          date: string
          amount: number
          comment: string
        }>(
          `${process.env.REACT_APP_API_URL}/api/v1/bonuses/${driverId}/${bonusId}`
        )
        setDate(bonus.data.date.replace('T00:00:00', ''))
        setAmount(bonus.data.amount)
        setComment(bonus.data.comment)
      } finally {
        setDisabled(false)
      }
    }

    loadBonus()
  }, [driverId, bonusId])

  const editFine = async (_: FormEvent) => {
    _.preventDefault()

    setDisabled(true)

    try {
      await Axios.put(
        `${process.env.REACT_APP_API_URL}/api/v1/bonuses/${bonusId}`,
        {
          date,
          amount,
          comment,
        }
      )

      toast.success('Надбавка обновлена.')
    } finally {
      setDisabled(false)
    }
  }

  return (
    <div className="row">
      <div className="col">
        <form onSubmit={editFine}>
          <fieldset disabled={disabled}>
            <div className="form-group">
              <label>
                <DriverFio driverId={driverId} />
              </label>
            </div>
            <div className="form-group">
              <label>Дата</label>
              <input
                className="form-control"
                required
                type="date"
                value={date.toString().replace('+00:00', '')}
                onChange={(_) => setDate(_.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Сумма</label>
              <input
                className="form-control"
                required
                type="number"
                value={amount}
                step={0.01}
                onChange={(_) => setAmount(parseFloat(_.target.value))}
              />
            </div>
            <div className="form-group">
              <label>Комментарий</label>
              <textarea
                className="form-control"
                rows={5}
                value={comment}
                onChange={(_) => setComment(_.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-success">
              <i className="fas fa-save"></i> Сохранить
            </button>
          </fieldset>
        </form>
      </div>
    </div>
  )
}
